import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { enableESimProfile } from '../api/esimProfilesActionsApi';

type UseESimProfileEnableProps = {
  iccid: string;
  eid: string;
  mutationOption?: Omit<UseMutationOptions, 'mutationFn'>;
};

export const useESimProfileEnable = ({
  iccid,
  eid,
  mutationOption = {},
}: UseESimProfileEnableProps) => {
  const { mutate } = useMutation({
    ...mutationOption,
    mutationFn: () => {
      return enableESimProfile({ iccid, eid });
    },
  });

  return {
    enableESimProfile: mutate,
  };
};
